<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 15:18:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-08 11:27:13
 * @name: 主组件
 * @Description: 主组件,挂载最外层routerView
 * @FilePath: \backstage\src\App.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div id="app">
    <keep-alive :include="cashRouters">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "App",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    }
  }
};
</script>
<style lang="scss">
#app{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>